module.exports = __webpack_public_path__ + "img/auth-one-bg.de82e7fa.jpg";